import icons from '../icons';

/**
 * Return the icon object
 * transforms the legacy path only implementation to a v2 object that can
 * extend with Title in the future.
 * NOTE: If all the icons in the icons.js file have been converted, this function can be deprecated
 * @param iconName
 */
const getIcon = iconName => {
  const iconValue = icons[iconName];

  if (typeof iconValue === 'string') {
    return {
      path: iconValue,
    };
  }

  if (typeof iconValue === 'object') {
    return iconValue;
  }

  throw new Error(`Unable to locate icon with supplied identifier: ${iconName}`);
};

const getIconPath = iconName => getIcon(iconName).path;

export { getIcon, getIconPath };
